import { Response } from "../../interfaces/utils/utils.interface";
import { TwoFactorUpdateRequest } from "../../interfaces/admin/admin.interface";
import httpService from "../../plugins/axios";

class TwoFactorService {
  // Get current admin's 2FA settings
  async getMy2FASettings(): Promise<Response> {
    try {
      const response = await httpService.get("/admin/2fa/my-settings");
      return response.data;
    } catch (error: any) {
      throw error.response?.data || error;
    }
  }

  // Update current admin's 2FA settings
  async updateMy2FASettings(data: TwoFactorUpdateRequest): Promise<Response> {
    try {
      const response = await httpService.put("/admin/2fa/my-settings", data);
      return response.data;
    } catch (error: any) {
      throw error.response?.data || error;
    }
  }
}

export default new TwoFactorService();
